// extracted by mini-css-extract-plugin
export var tosLink = "_7d-0";